<template>
    <div class="modal_bindings">
    <div class="content">
      <div class="response_table">
        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th scope="col">
                {{ translate('sim_server.bindings_history.fid') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.bindings_history.slot') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.bindings_history.status') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.bindings_history.user_name') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.bindings_history.ts_update') }}
              </th>
            </tr>
          </thead>
            <tbody>
              <tr v-for="(binding, key) in bindings_history" :key="key">
                <td :data-label="translate('sim_server.bindings_history.fid')">
                  {{ binding.fid }}
                </td>
                <td :data-label="translate('sim_server.bindings_history.slot')">
                  {{ binding.slot }}
                </td>
                <td :data-label="translate('sim_server.bindings_history.status')">
                  {{ binding.status }}
                </td>
                <td :data-label="translate('sim_server.bindings_history.user_name')">
                  {{ binding.user_name }}
                </td>
                <td :data-label="translate('sim_server.bindings_history.ts_update')">
                  {{ get_date(binding.ts_update) }}
                </td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>



export default {
    name: "BindingsHistory",
    props: ['bindings_history'],
    data () {
        return {
            options: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }
        }
    },

    methods: {
        close () {
            this.$emit('close')
        },
        async go_to_device (fid) {
            await this.close()
            await this.$router.push({path: '/device/' + fid})
        },

    }
}
</script>
<style lang="scss" scoped>
.modal_bindings{
    table{
        width: 100%;
        tbody{
            max-height: 400px;
        }
        tr{
            border: 1px solid #ddd;
        }
        td, th{
            text-align: center;
            a{
              cursor: pointer;
            }
        }
    }
}

</style>
